const BUILD_TARGETS = new Set(['production', 'beta', 'review']);
const PRODUCT_LANGUAGE_ACTIVATIONS = new Set(['disabled', 'enabled']);

function parseBuildTarget(value) {
    const target = value || 'production';
    if (!BUILD_TARGETS.has(target)) {
        throw new Error(`Unsupported i18n build target: ${target}`);
    }
    return target;
}

function parseProductLanguageActivation(value) {
    const activation = value || 'disabled';
    if (!PRODUCT_LANGUAGE_ACTIVATIONS.has(activation)) {
        throw new Error(`Unsupported product-language activation: ${activation}`);
    }
    return activation;
}

function assertProductLanguageActivation(targetValue, activationValue) {
    const target = parseBuildTarget(targetValue);
    const activation = parseProductLanguageActivation(activationValue);
    if (target !== 'production' && activation !== 'disabled') {
        throw new Error(
            `Product-language activation must remain disabled for ${target} artifacts`
        );
    }
    return activation;
}

function assertReviewMarker(target, reviewArtifact) {
    if (target === 'review' && !reviewArtifact) {
        throw new Error(
            'The review i18n build target requires an explicit non-promotable review artifact marker'
        );
    }
}

function isStageVisible(stage, targetValue, reviewArtifact = false) {
    const target = parseBuildTarget(targetValue);
    if (stage === 'retired') return false;
    if (target === 'production') return stage === 'live';
    if (target === 'beta') return stage === 'live' || stage === 'preview';
    return reviewArtifact && ['planned', 'preview', 'live'].includes(stage);
}

function visibleManagedLocales(registry, targetValue, reviewArtifact = false) {
    const target = parseBuildTarget(targetValue);
    assertReviewMarker(target, reviewArtifact);
    const locales = registry.locales.filter(({ stage }) => (
        isStageVisible(stage, target, reviewArtifact)
    ));
    if (!locales.some(({ tag }) => tag === registry.defaultLocale)) {
        throw new Error('The default locale must be visible in every build target');
    }
    return locales;
}

module.exports = {
    assertProductLanguageActivation,
    assertReviewMarker,
    isStageVisible,
    parseBuildTarget,
    parseProductLanguageActivation,
    visibleManagedLocales,
};
